import React from 'react';
import { Login } from '../../../types/models/login';
import styled from 'styled-components';
import { DateAttr } from '../../../components/date-attr';

const ListItem = styled.li`
  display: grid;
  grid-template-columns: 5em 2fr 2fr;
  grid-gap: 1em;
`;
interface LoginItemProps {
  login: Login;
}

export function LoginItem(props: LoginItemProps) {
  return (
    <>
      <ListItem>
        <DateAttr date={props.login.loginDate} />
        <span>{props.login.serviceProviderName}</span>
        <span>{props.login.username}</span>
      </ListItem>
    </>
  );
}
